// The Atomic Lab mark (a lab flask). client/logo.svg is also the favicon.
import markup from '../logo.svg';
import { h } from '../util/dom.ts';

/** The logo at `size` CSS px; decorative, so hidden from assistive tech (the name sits beside it). */
export function logoMark(size: number): HTMLElement {
  const el = h('span', { class: 'logo', 'aria-hidden': 'true' });
  el.innerHTML = markup;
  const svg = el.firstElementChild as SVGElement;
  svg.setAttribute('width', String(size));
  svg.setAttribute('height', String(size));
  svg.removeAttribute('role');
  return el;
}
